import React, { Component } from 'react';
import { Field } from 'redux-form';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchDropdown } from '../../../actions/actionCreators';

import { renderSearchMultipleDropdown, renderSearchDropDown } from '../../common/form/FieldHelper';

class ItemMatrixAttributeDropdown extends Component {

  render() {

    const {
      name,
      form,
      searchFn,
      onPostChange,
      multiple,
    } = this.props;

    return (
      <div className="field">
        <Field
          {...this.props}
          name={name}
          formId={form}
          searchFn={searchFn}
          dropdownType='item_matrix_attribute'
          type='item_matrix_attribute'
          valueField="id"
          component={multiple ? renderSearchMultipleDropdown : renderSearchDropDown}
          onPostChange={onPostChange}
        />
      </div>
    );
  }
}


function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    searchFn: fetchDropdown
  }, dispatch);
}

export default connect(null, mapDispatchToProps)(ItemMatrixAttributeDropdown);

